
export const note = (showFMGNote) => {
    let windSpeedNote = `<div class= "input-note">
        ${showFMGNote ? `wind speed as per fm global wind maps` : 
            `Verify the ASCE loading conditions provided on this page <a target="_blank" 
            href="https://asce7hazardtool.online/">CLICK HERE</a>`}
        </div>`;
    
    return windSpeedNote;
}